import { Component } from '@angular/core';
import { MatTab, MatTabChangeEvent, MatTabContent, MatTabGroup } from '@angular/material/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { CustomFiltersComponent } from './custom-filters/custom-filters.component';
import { EndpointParametersComponent } from './endpoint-parameters/endpoint-parameters.component';

@Component({
  imports: [MatTab, MatTabContent, MatTabGroup, TranslatePipe, CustomFiltersComponent, EndpointParametersComponent],
  selector: 'app-filter-settings',
  styleUrl: './filter-settings.component.scss',
  templateUrl: './filter-settings.component.html',
})
export class FilterSettingsComponent {
  public customFiltersTabSelect$: Subject<void> = new Subject<void>();
  public endpointParametersTabSelect$: Subject<void> = new Subject<void>();

  public changeTabActions($event: MatTabChangeEvent): void {
    switch ($event.index) {
      case 0:
        this.endpointParametersTabSelect$.next();

        break;
      case 1:
        this.customFiltersTabSelect$.next();

        break;
    }
  }
}
